import Vue from 'vue'
import SuiVue from 'semantic-ui-vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'

import FontAwesome from './plugins/fontawesome'
import TPlaceholder from '@/components/placeholder'
import TModal from '@/components/modal/import'
import TModalExport from '@/components/modal/export'
import TBreadcrumb from '@/components/breadcrumb'
import TModalRegister from '@/components/modal/register'
import TStatusBar from '@/components/statusbar'
import TPagination from '@/components/pagination'

import http from '@/services/http'
import './plugins/webfonts'
import './registerServiceWorker'
import 'semantic-ui-css/semantic.min.css'
import './plugins/graphql'
import './plugins/scrollto'
import './plugins/datepicker'

import router from './router'
import store from './store'

Vue.component('TIcon', FontAwesome)
Vue.component('TPlaceholder', TPlaceholder)
Vue.component('TBreadcrumb', TBreadcrumb)
Vue.component('TModal', TModal)
Vue.component('TModalRegister', TModalRegister)
Vue.component('TModalExport', TModalExport)
Vue.component('TStatusBar', TStatusBar)
Vue.component('TPagination', TPagination)

Vue.config.productionTip = false

Vue.prototype.$http = http

window.Vue = Vue

Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(SuiVue)

new Vue({
  router,
  store,
  render(h) { return h(App); },
}).$mount('#app')
